
import { supabase } from '@/integrations/supabase/client';
import { getMockAppointments } from './mockAppointmentService';
import { baseApiService } from '../base/baseApiService';

/**
 * Service for time slot related operations
 */
export const timeSlotService = {
  /**
   * Check availability of a time slot
   * @param doctorId Doctor ID
   * @param date Date string in YYYY-MM-DD format
   * @param timeSlot Time slot string 
   */
  checkAvailability: async (doctorId: number | string, date: string, timeSlot: string): Promise<boolean> => {
    try {
      // Check if there's already an appointment for this doctor, date, and time slot
      const { data, error, count } = await supabase
        .from('appointments')
        .select('id', { count: 'exact' })
        .eq('doctor_id', doctorId.toString())
        .eq('date', date)
        .eq('time_slot', timeSlot)
        .eq('status', 'confirmed');
        
      if (error) throw error;
      
      const isAvailable = count === 0;
      console.log('Availability check result:', isAvailable);
      return isAvailable;
    } catch (error: any) {
      console.error('Error checking availability:', error);
      
      // For development mode, check availability against mock data
      if ((import.meta.env.DEV || import.meta.env.MODE === 'development') && 
          baseApiService.useMockData()) {
        console.warn('Using mock availability check due to API error');
        const appointments = getMockAppointments();
        
        // Check if there's already an appointment for this doctor, date, and time slot
        const conflictingAppointment = appointments.find(
          app => 
            app.doctorId.toString() === doctorId.toString() && 
            app.date === date && 
            app.timeSlot === timeSlot && 
            app.status === 'confirmed'
        );
        
        const isAvailable = !conflictingAppointment;
        console.log('Mock availability check result:', isAvailable);
        return isAvailable;
      }
      
      // In case of API error in production, return true to allow booking attempt
      // The server-side validation will catch any conflicts
      return true;
    }
  }
};
